import { SaleNotification } from "./notifcation-sale";
import { TaskNewMessageNotification } from "./notifcation-task-new-message";
import { Notification } from "./notification";
import { AwsFileNotification } from "./notification-aws-file";
import { CustomNotification } from "./notification-custom";
import { DossierDataMissingNotification } from "./notification-dossiewr-data-missing";
import { NewCrmAssignedNotification } from "./notification-new-crm-assigned";
import { CalendarReminderNotification } from "./notification-calendar-reminder";
import { NewPeppolOrderNotification } from "./notification-new-peppol-order";
import { PdfArchiveCreatedNotification } from "./notification-pdf-archive-created";
import { PublicSaleNotification } from "./notification-public-sale";
import { ReportCreatedNotification } from "./notification-report-created";
import { SalesNotification } from "./notification-sales";
import { UblArchiveCreatedNotification } from "./notification-ubl-archive-created";

export class NotificationBuilder extends Notification {
	private constructor(data:any){
		super(data);
	}

	// eslint-disable-next-line max-lines-per-function
	public static createNotification(data:any):Notification{
		if (data.IsCustom) {
			return new CustomNotification(data);
		}
		if (data.Title == "title-tasks-new-message"){
			return new TaskNewMessageNotification(data);
		}
		if (data.Title == "title-new-peppol-order"){
			return new NewPeppolOrderNotification(data);
		}
		if (data.Title == "title-new-crm-assigned") {
			return new NewCrmAssignedNotification(data);
		}
		if (data.Title == "title-calendar-reminder") {
			return new CalendarReminderNotification(data);
		}
		if (data.Title == "title-sale-from-frequency-document-created") {
			return new SaleNotification(data);
		}
		if (data.Title == "title-sale-from-frequency-document-send-failed") {
			return new SaleNotification(data);
		}
		if (data.Title == "title-report-created"){
			return new ReportCreatedNotification(data);
		}
		if (data.Title == "title-ubl-archive-created") {
			return new UblArchiveCreatedNotification(data);
		}
		if (data.Title == "title-ubl-purchase-archive-created") {
			return new UblArchiveCreatedNotification(data);
		}
		if (data.Title == "title-create-archive-ready") {
			return new PdfArchiveCreatedNotification(data);
		}
		if (data.Title == "title-dossier-data-missing") {
			return new DossierDataMissingNotification(data);
		}
		if (data.Title == "title-sale-signed") {
			return new PublicSaleNotification(data);
		}
		if (data.Title == "title-products-imported") {
			return new AwsFileNotification(data);
		}
		if (data.Title == "title-contacts-imported") {
			return new AwsFileNotification(data);
		}
		if (data.Title == "title-auto-reminders-reminder-sent") {
			return new SalesNotification(data);
		}
		return new Notification(data);
	}
}